import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter
} from '@angular/core';
import { CRON_RATE } from '@appgen-health-crm/data';

@Component({
  selector: 'recurring-task-slot',
  templateUrl: './recurring-task-slot.component.html',
  styleUrls: ['./recurring-task-slot.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RecurringTaskSlotComponent implements OnInit {
  @Input() start: Date = null;
  @Input() edit: boolean;
  @Input() error: string;

  @Output() timeChanged = new EventEmitter<{ sDate: Date }>();
  @Output() deleteClicked = new EventEmitter();
  cronRate = CRON_RATE;
  constructor() {}
  ngOnInit(): void {}

  delete() {
    this.deleteClicked.emit();
  }

  changeHandler() {
    this.timeChanged.emit({ sDate: this.start });
  }
}
